export const NotEligibleCardErrorMessage = 'C1-01';
export const NotAccessibleEmailErrorMessage = 'C1-02';
export const CP1ContactUsLink = 'https://www.capitalone.com/help-center/contact-us/';